import {createSelector} from 'reselect';

export const userBranch = state => state.user;

export const profileSelector = createSelector(
    userBranch,
    user => user.profile
);

export const userEmailSelector = createSelector(
    profileSelector,
    profile => profile.email
);

export const userUsernameSelector = createSelector(
    profileSelector,
    profile => profile.username
);

export const walletSelector = createSelector(
    profileSelector,
    profile => profile.wallet
);

export const dashboardTokenSelector = createSelector(
    profileSelector,
    profile => profile.dashboard_token
);

export const dateCreatedSelector = createSelector(
    profileSelector,
    profile => profile.date_created
);

export const lastLoginSelector = createSelector(
    profileSelector,
    profile => profile.last_login
);

export const lastIPAddressSelector = createSelector(
    profileSelector,
    profile => profile.last_ip_address
);



// WEBPACK FOOTER //
// /src/redux/selectors/user.js